import { render } from "./TaiXe.vue?vue&type=template&id=089d187f&scoped=true"
import script from "./TaiXe.vue?vue&type=script&lang=js"
export * from "./TaiXe.vue?vue&type=script&lang=js"

import "./TaiXe.vue?vue&type=style&index=0&id=089d187f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089d187f"]])

export default __exports__